import { render, staticRenderFns } from "./AddressListItem.vue?vue&type=template&id=23ff8fba&scoped=true&"
import script from "./AddressListItem.vue?vue&type=script&lang=js&"
export * from "./AddressListItem.vue?vue&type=script&lang=js&"
import style0 from "./AddressListItem.vue?vue&type=style&index=0&id=23ff8fba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ff8fba",
  null
  
)

export default component.exports